import { Column } from "@/components";
import { DashboardPeriodToggle } from "@/components/dashboard/dashboard-stats/main-stats/DashboardPeriodToggle";

import { GoalPeriod } from "@/types";

// The week/month toggle, parked in the corner of whichever goal panel is
// selected — only one is ever on screen.
export const GoalPanelPeriodToggle = ({
  onPeriodChange,
  period,
}: {
  onPeriodChange: (period: GoalPeriod) => void;
  period: GoalPeriod;
}) => (
  <Column className="absolute right-3 top-3">
    <DashboardPeriodToggle
      isAbbreviated
      onPeriodChange={onPeriodChange}
      period={period}
    />
  </Column>
);
